import React from 'react';
import { Switch } from 'react-router-dom';
import PrivateRoute from '../../components/shared/PrivateRoute';
import DashboardLayout from '../../layouts/DashoardLayout';
import { Box, Paper } from '../../ui/core';
import { flushPageSx, surfaceCardSx } from '../../ui/styles';

import RideDetails from './RideDetails';

const RidesShell = () => (
  <Box sx={flushPageSx}>
    <Paper elevation={0} sx={{ ...surfaceCardSx, flex: 1, minWidth: 0 }}>
      <Switch>
        <PrivateRoute exact path="/rides/:id" component={RideDetails} />
      </Switch>
    </Paper>
  </Box>
);

const Rides = () => (
  <DashboardLayout flush title="Rides">
    <RidesShell />
  </DashboardLayout>
);

export default Rides;
